// extracted by mini-css-extract-plugin
var _1 = "#a3611f";
export { _1 as "primary" }
